import React from 'react'
import HCaptcha from '@hcaptcha/react-hcaptcha'

const Captcha = ({ onChange }) => {
    return (
        <HCaptcha
            sitekey="22d1911f-5f02-486a-b6df-1b58b9d5c2c2"
            onVerify={onChange}
        />
    )
}

export default Captcha
